import React from "react";

export default function VideoComex({
  video,
  poster,
  controls = !true,
  autoPlay = !true,
  muted = !true,
  loop = !true,
}) {
  return (
    <section className="w-full  py-16 flex flex-col items-center justify-center">
      <div className="w-full aspect-video h-[80vh]  overflow-hidden mb-8">
        <video
          controls={controls}
          autoPlay={autoPlay}
          muted={muted}
          loop={loop}
          poster={`https://api.institucional.global.sidom.io${poster}`}
          className="w-full h-full object-cover shadow-md"
        >
          <source
            src={`https://api.institucional.global.sidom.io${video}`}
            type="video/mp4"
          />
          Tu navegador no soporta la reproducción de video.
        </video>
      </div>
    </section>
  );
}
